import regeneratorRuntime from "regenerator-runtime";
import Utilitiesjs from '../utilites';
import Ajaxjs from '../ajax';

export default class Calendarjs {
    constructor() {
        this.utilsjs = new Utilitiesjs;
        this.ajaxjs = new Ajaxjs;
    }


    loadCalendar(events, dynamicLink, locale) { 
        const that = this;
        $('#calendar').fullCalendar({
            eventClick: function (calEvent) {
                window.open(`${window.location.protocol}//${window.location.host}/${dynamicLink}/${calEvent.dynamicPath}`, '_blank');
            },
            events,
            locale: locale, // adding language support
            displayEventTime: false,
            timeFormat: 'h(:mm)t' // uppercase H for 24-hour clock 'H(:mm)'
        });
    }

    dynamicPageUrl() {

    }
}




// WEBPACK FOOTER //
// ./Scripts/es6/controllers/calendar.js